export default __webpack_public_path__ + "static/media/wen-hope-pepe.ff1f253a.jpeg";